var map = {
	"./template.betgalaxy": 2129,
	"./template.betgalaxy.tsx": 2129,
	"./template.betprofessor": 2016,
	"./template.betprofessor.tsx": 2016,
	"./template.betroyale": 2017,
	"./template.betroyale.tsx": 2017,
	"./template.default": 708,
	"./template.default.tsx": 708,
	"./template.fiestabet": 1956,
	"./template.fiestabet.tsx": 1956,
	"./template.forsport": 1957,
	"./template.forsport.tsx": 1957,
	"./template.goldenrush": 2018,
	"./template.goldenrush.tsx": 2018,
	"./template.juicybet": 2019,
	"./template.juicybet.tsx": 2019,
	"./template.junglebet": 2020,
	"./template.junglebet.tsx": 2020,
	"./template.oldgill": 2021,
	"./template.oldgill.tsx": 2021,
	"./template.puntcity": 2022,
	"./template.puntcity.tsx": 2022,
	"./template.puntgenie": 1985,
	"./template.puntgenie.tsx": 1985,
	"./template.questbet": 2023,
	"./template.questbet.tsx": 2023,
	"./template.sterlingparker": 2024,
	"./template.sterlingparker.tsx": 2024,
	"./template.sugarcastle": 2025,
	"./template.sugarcastle.tsx": 2025,
	"./template.ts": 1000,
	"./template.vikingbet": 2130,
	"./template.vikingbet.tsx": 2130,
	"./template.volcanobet": 1990,
	"./template.volcanobet.tsx": 1990,
	"./template.wellbet": 2026,
	"./template.wellbet.tsx": 2026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2807;